module.exports = __webpack_public_path__ + "img/52002735_L.981d611d.png";